export const getPhotos = async (category, subcategory) => {
  if (!category) return [];
  let path;
  if (category && subcategory) {
    path = `/compressed/${category}/${subcategory}/index.json`;
  } else if (category) {
    path = `/compressed/${category}/index.json`;
  }
  const response = await fetch(path);
  if (!response.ok) {
    console.error(`Failed to fetch: ${path}`);
    return [];
  }
  const files = await response.json();
  return files.map((filename) => ({
    path: `/compressed/${category}${
      subcategory ? `/${subcategory}` : ""
    }/${filename}`,
    name: filename.replace(/\.[^/.]+$/, ""),
  }));
};

export const getCategories = async () => {
  const response = await fetch("/compressed/index.json");
  if (!response.ok) {
    console.error("Failed to fetch: /compressed/index.json");
    return [];
  }
  return await response.json();
};

export const getSubcategories = async (category) => {
  if (!category) return [];
  const response = await fetch(`/compressed/${category}/index.json`);
  if (!response.ok) {
    console.error(`Failed to fetch: /compressed/${category}/index.json`);
    return [];
  }
  return await response.json();
};
